import { useAddChild } from '@/features/profile/MinorChildren/hooks/useAddChild';
import { useEditChild } from '@/features/profile/MinorChildren/hooks/useEditChild';
import { ChildModalMode } from '@/features/profile/MinorChildren/ChildModal/ChildModal.types';

export const useAddOrEditChild = ({ mode }: { mode: ChildModalMode }) => {
    const addChild = useAddChild();
    const editChild = useEditChild();

    if (mode.isAdding) {
        return addChild;
    }

    if (mode.isEditing) {
        return editChild;
    }

    return {
        mutate: async () => Promise.resolve(), // No-op function as fallback
        status: 'idle',
        errorMessage: '',
        reset: () => {},
    };
};
